import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequestIIS from 'BaseServiceRequestIIS';

class GetBlockRequest extends BaseServiceRequestIIS {
  constructor(symbol, graphtype, enddate, startdate, fcQtrs, isFinancialBlockVisible, isOwnershipBlockVisible, wonOnly = 1, revWonOnly = 0) {
    super();
    super.addRequestUri("FindGetBlocks2");
    super.addPathParameter("symbol", symbol);
    super.addPathParameter("graphType", graphtype);
    super.addPathParameter("endDate", enddate);
    super.addPathParameter("startDate", startdate);
    super.addPathParameter("FcQuarters", fcQtrs);
    super.addPathParameter("GetFinancial", false);
    super.addPathParameter("GetCustomFinancialBlock", isFinancialBlockVisible);
    super.addPathParameter("GetOwnership", isOwnershipBlockVisible);
    super.addPathParameter("size", "SMALL");
    super.addPathParameter("wonOnly", wonOnly);
    super.addPathParameter("revWonOnly", revWonOnly);
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }

  getMessageName() {
    return undefined;
  }
}
export default GetBlockRequest;
